export default __webpack_public_path__ + "static/media/background_mobile.ff2db041.webp";